<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon> {{labels.selectionCriteria}}
                </div>
              </v-expansion-panel-header>
                <v-expansion-panel-content class="ePanelHeaderColor">
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker v-model="reportForm.tranDateFrom" :label="labels.tranDateFrom" :data-vv-as="labels.tranDateFrom"
                          data-vv-name="reportForm.tranDateFrom" :error-messages="errors.collect('reportForm.tranDateFrom')" v-validate="tranDateFromValidation"></cal-picker>
                        </v-flex>

                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker v-model="reportForm.tranDateTo" :label="labels.tranDateTo" :data-vv-as="labels.tranDateTo"
                          data-vv-name="reportForm.tranDateTo" :error-messages="errors.collect('reportForm.tranDateTo')" v-validate="tranDateToValidation"></cal-picker>
                        </v-flex>

                        <v-flex xs12 md6 lg6>
                          <v-autocomplete :items="driList" v-model="reportForm.dri" :label="labels.dri" item-text="label" item-value="value"
                          data-vv-name="dri" :data-vv-as="labels.dri" :error-messages="errors.collect('dri')" v-validate="'required'"
                          :loading="loading"></v-autocomplete>
                        </v-flex>

                        <v-flex xs12 md6 lg6>
                          <v-autocomplete multiple :items="printOptionList" v-model="reportForm.printOption" :label="labels.printOption" item-text="label" item-value="value"
                          data-vv-name="printOption" :data-vv-as="labels.printOption" :error-messages="errors.collect('printOption')" v-validate="'required'"
                          :loading="loading"></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>

        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon> {{labels.addSelectionCriteria}}
                </div>
              </v-expansion-panel-header>
                <v-expansion-panel-content class="ePanelHeaderColor">
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 md6 lg6>
                          <v-autocomplete :items="allSelectedList" v-model="reportForm.fund" :label="labels.fund" item-text="label" item-value="value"
                          data-vv-name="fund" :data-vv-as="labels.fund" :error-messages="errors.collect('fund')" v-validate="'required'"
                          :loading="loading" @change="doFund"></v-autocomplete>
                        </v-flex>

                        <v-flex xs12 md6 lg6 v-if="reportForm.fund === 'Selected'">
                          <v-autocomplete multiple :items="fundList" v-model="reportForm.cFund" :label="labels.cFund" item-text="label" item-value="value"
                          data-vv-name="cFund" :data-vv-as="labels.cFund" :error-messages="errors.collect('cFund')" v-validate="'required'"
                          :loading="loading"></v-autocomplete>
                        </v-flex>

                        <v-flex xs12 md6 lg6 v-else></v-flex>

                        <v-flex lg12 md12 xs12>
                          <v-text-field v-model="reportForm.execIC" :label="labels.execIC" :error-messages="errors.collect('execIC')" data-vv-name="execIC"
                          :data-vv-as="labels.execIC" append-icon="mdi-magnify" @click:append="getHelpList()" readonly></v-text-field>
                        </v-flex>

                        <v-flex xs12 md6 lg6>
                          <v-autocomplete :items="allSelectedExcludeList" v-model="reportForm.acctNoSfx" :label="labels.acctNoSfx" item-text="label" item-value="value"
                          data-vv-name="acctNoSfx" :data-vv-as="labels.acctNoSfx" :error-messages="errors.collect('acctNoSfx')" v-validate="'required'"
                          :loading="loading" @change="doAcctNoSfx"></v-autocomplete>
                        </v-flex>

                        <v-flex xs12 md6 lg6 v-if="reportForm.acctNoSfx === 'Selected'">
                          <v-autocomplete multiple :items="acctNoSfxList" v-model="reportForm.cAcctNoSfx" :label="labels.cAcctNoSfx" item-text="label" item-value="value"
                          data-vv-name="cAcctNoSfx" :data-vv-as="labels.cAcctNoSfx" :error-messages="errors.collect('cAcctNoSfx')" v-validate="'required'"
                          :loading="loading"></v-autocomplete>
                        </v-flex>

                        <v-flex xs12 md6 lg6 v-else></v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-checkbox
            :label="labels.pbPrtParam"
            v-model="reportForm.pbPrtParam"
            :error-messages="errors.collect('pbPrtParam')"
            data-vv-name="pbPrtParam"
             :data-vv-as="labels.pbPrtParam"
          />
        </v-flex>
        <v-flex xs12 sm6 md6 lg6>
          <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
              {{labels.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="reportForm.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="execICHelpList" width="900px" persistent>
      <multi-exec-in-charge-help-list :execic="reportForm.execIC" @close="doClose" @doAssign="doAssign($event)"></multi-exec-in-charge-help-list>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import clone from 'clone'
import MultiExecInChargeHelpList from '@/components/core/common/dialog/MultiExecInChargeHelpList'

export default {
  data() {
    return {
      labels: {
        tranDateFrom: 'From Transaction Date*',
        tranDateTo: 'To Transaction Date*',
        dri: 'Direct/RI',
        printOption: 'Print Option(s)*',
        selectionCriteria: 'Selection Criteria',
        addSelectionCriteria: 'Additional Selection Criteria',
        fund: 'Fund(s)',
        cFund: 'Selected Fund(s)*',
        acctNoSfx: 'Exclude Account No. Suffix(es)',
        cAcctNoSfx: 'Selected Account No. Suffix(es)*',
        execIC: 'Executive(s) In-charge',
        export: 'Export To',
        format: 'ASCII TEXT',
        pbPrtParam: 'Print Runtime Parameters'
      },
      reportForm: {
        tranDateFrom: null,
        tranDateTo: null,
        dri: 'Both',
        printOption: '',
        fund: 'All',
        cFund: '',
        acctNoSfx: 'None',
        cAcctNoSfx: '',
        execIC: 'All',
        format: undefined,
        pbPrtParam: true
      },
      loading: false,
      menu: {},
      supportedFormat: [],
      fundList: [],
      acctNoSfxList: [],
      execICHelpList: false,
      driList: [
        {
          label: 'Both',
          value: 'Both'
        },
        {
          label: 'Direct',
          value: 'D'
        },
        {
          label: 'RI',
          value: 'R'
        }
      ],
      printOptionList: [
        {
          label: 'Details',
          value: 'Details'
        },
        {
          label: 'Summary',
          value: 'Summary'
        },
        {
          label: 'Exceptional',
          value: 'Exceptional'
        }
      ],
      allSelectedList: [
        {
          label: 'All',
          value: 'All'
        },
        {
          label: 'Selected',
          value: 'Selected'
        }
      ],
      allSelectedExcludeList: [
        {
          label: 'None',
          value: 'None'
        },
        {
          label: 'Selected',
          value: 'Selected'
        }
      ],
      panel1: [0],
      panel2: [0]
    }
  },
  computed: {
    riMenu() {
      return this.$store.state.reports.riReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    tranDateFromValidation() {
      if (this.reportForm.tranDateFrom !== '' && this.reportForm.tranDateFrom !== null && this.reportForm.tranDateFrom !== undefined) {
        return 'entry|valTranDateFrom:' + this.reportForm.tranDateTo
      } else {
        return 'required'
      }
    },
    tranDateToValidation() {
      if (this.reportForm.tranDateTo !== '' && this.reportForm.tranDateTo !== null && this.reportForm.tranDateTo !== undefined) {
        return 'entry|valTranDateTo:' + this.reportForm.tranDateFrom
      } else {
        return 'required'
      }
    }
  },
  watch: {
  },
  methods: {
    async doInit() {
      this.reportForm.tranDateTo = new Date()
      try {
        if (this.$store.state.reports.riReports.menu !== 1) {
          await Promise.all([this.$store.dispatch('riReportsInit')])
        }
        const apiURI = this.riMenu.contrtCert
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
        this.getFundList()
        this.getAcctNoSfxList()
      } catch (err) {
        throw err
      }
    },
    async getFundList() {
      const apiURI = this.menu.fundList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const data = result.data.data
          this.fundList = []
          if (data) {
            for (let i in data) {
              this.fundList.push({ value: data[i].value, label: data[i].label })
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doFund() {
      if (this.reportForm.fund === 'All') {
        this.reportForm.cFund = ''
      }
    },
    async getAcctNoSfxList() {
      const apiURI = this.menu.acctNoSfxList
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const data = result.data.data
          this.acctNoSfxList = []
          if (data) {
            for (let i in data) {
              this.acctNoSfxList.push({ value: data[i].value, label: data[i].label })
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doAcctNoSfx() {
      if (this.reportForm.acctNoSfx === 'None') {
        this.reportForm.cAcctNoSfx = ''
      }
    },
    getHelpList() {
      this.execICHelpList = true
    },
    doClose() {
      this.execICHelpList = false
    },
    async doAssign(Obj) {
      this.reportForm.execIC = Obj.finalSelectedItems.toString()
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      for (let i in this.reportForm.printOption) {
        let apistr = 'export' + this.reportForm.printOption[i]
        const apiURI = this.menu[apistr]
        if (apiURI) {
          try {
            this.loading = true
            let expand = clone(this.reportForm)
            if (expand.cFund) {
              expand.cFund = this.reportForm.cFund.join()
            }
            if (expand.printOption) {
              expand.printOption = this.reportForm.printOption.join()
            }
            if (expand.cAcctNoSfx) {
              expand.cAcctNoSfx = this.reportForm.cAcctNoSfx.join()
            }
            await Promise.all([this.$http.post(apiURI, expand)])
            this.loading = false
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
            this.loading = false
          }
        } else {
          this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        }
      }
    }
  },
  created() {
    this.polNoApiUrl = this.$store.state.underwriting.dataTransferSettings.menu.polNoList

    this.$validator.extend('valTranDateFrom', {
      getMessage(field, args) {
        return 'Must be same date or earlier date than To Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranFromDate = args[0]
        if (tranFromDate) {
          return !(isAfter(removeTime(value), removeTime(tranFromDate)))
        }
      }
    })

    this.$validator.extend('valTranDateTo', {
      getMessage(field, args) {
        return 'To Date must be greater or equal to From Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranToDate = args[0]
        if (tranToDate) {
          return !(isAfter(removeTime(tranToDate), removeTime(value)))
        }
      }
    })
  },
  beforeMount() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
    MultiExecInChargeHelpList
  }
}
</script>

<style>

</style>
